import { render, staticRenderFns } from "./RowNode.vue?vue&type=template&id=23d48be2&scoped=true&"
import script from "./RowNode.vue?vue&type=script&lang=js&"
export * from "./RowNode.vue?vue&type=script&lang=js&"
import style0 from "./RowNode.vue?vue&type=style&index=0&id=23d48be2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d48be2",
  null
  
)

export default component.exports